import { Switch } from "@mantine/core";
import "./styles.scss";

interface Props {
  label: string,
  checked: boolean,
  toggleChart: (v: boolean) => void
}

function Toggler({ label, checked, toggleChart }: Props) {
  return (
    <Switch
      className="toggler"
      checked={checked}
      onChange={(e) => toggleChart(e.currentTarget.checked)}
      label={label}
      size="xs"
      radius="md"
      color="blue"
    />
  )
}

export default Toggler;
